import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../@core/auth/models';
import { Settings } from '../@core/enums/system-settings.enum';
import { ApiClientService } from '../@core/services/api-client.service';
import { ProceduresSettings } from '../procedures/enums';
import { UserService } from '../student/services/user.service';
import { ApplicationRoutes } from '../@core/routes/application-routes.const';
import { UserModel } from '../student/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUser: BehaviorSubject<User | UserModel | null> = new BehaviorSubject<User | UserModel | null>(null as any);
  isAdfsLogin: boolean = false;
  constructor(
    private apiClientService: ApiClientService,
    private cookieService: CookieService,
    private permissionsService: NgxPermissionsService,
    private userService: UserService,
    private router: Router
  ) { }


  logIn(loginInfo: any) {
    return this.apiClientService.create(
      ApplicationRoutes.Authentications.Controller,
      loginInfo
    );
  }

  SSOLogin() {
    return this.apiClientService.get(
      ApplicationRoutes.Authentications.SsoLogin
    );
  }

  CheckUserExist(email: string) {
    return this.apiClientService.get(ApplicationRoutes.Authentications.EmailIsExistValidation(email));
  }

  getAccess(code: string) {
    return this.apiClientService.get(ApplicationRoutes.Authentications.TokenCodeValidation(code));
  }

  isAuthenticated(): boolean {
    if (this.cookieService.check('CasIU.Edu-cookie')) {
      return true;
    }
    const localstorage = this.getToken();
    return localstorage == null ? false : true;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  setToken(token: string, isAdfsLogin: boolean = false) {
    localStorage.setItem('token', token);
    this.isAdfsLogin = isAdfsLogin;
  }

  /**
   * Drops the local session without flushing permissions or navigating. Used by the sign-up flow,
   * which signs the new account in only long enough to upload its avatar with a token and then
   * returns the visitor to the sign-in screen.
   */
  clearSession() {
    localStorage.removeItem('token');
    delete environment.header.headers['Authorization'];
  }

  initAnonymousSettings() {
    this.permissionsService.addPermission(Settings.ProfileCompleted);

    if (environment.showProcedures)
      this.permissionsService.addPermission(ProceduresSettings.ShowProcedures);
    
    this.currentUser.next(null);
  }

  loadUserData() {
    let promise = new Promise<any>((resolve, reject) => {
      this.userService.getCurrent().subscribe(
        (Response: User) => {
          this.permissionsService.loadPermissions(Response.permissions);
          if (environment.showProcedures)
            this.permissionsService.addPermission(ProceduresSettings.ShowProcedures);

          if (Response.isProfileCompleted)
            this.permissionsService.addPermission(Settings.ProfileCompleted);
          else
            this.router.navigate(['/myspace']);

          this.currentUser.next(Response);
          resolve(Response);
        },
        (error: any) => {
          if (parseInt(error.status, 10) === 401) {
            this.logout();
            this.router.navigate(['/auth']);
            reject();
          }
        },
      );
    });
    return promise;
  }

  logout() {
    this.permissionsService.flushPermissions();
    this.cookieService.deleteAll();
    localStorage.clear();
    this.currentUser.next(null);
    // ADFS logout
    if (this.isAdfsLogin)
      window.open(environment.adfs.end_session_endpoint, '_blank', 'top=0,left=0,height=auto,width=auto');

    window.location.href = window.location.origin + '/home';
    // this.router.navigate(['/login']);
  }

  forgetPassword(form: any) {
    return this.apiClientService.create(
      ApplicationRoutes.Authentications.PasswordForgetting,
      form
    );
  }

  resetPassword(form: any) {
    return this.apiClientService.create(
      ApplicationRoutes.Authentications.PasswordResetting,
      form
    );
  }

  changePassword(form: any) {
    return this.apiClientService.create(
      ApplicationRoutes.Authentications.PasswordChanging,
      form
    );
  }

  getFirebaseToken() {
    return localStorage.getItem('firebaseToken');
  }
}
